import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconCertification = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M12 17.25a8.25 8.25 0 100-16.5 8.25 8.25 0 000 16.5z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.75 16.35l1.5 6.9-5.25-3-5.25 3 1.5-6.9",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M12.531 4.292l1.248 2.458h2.127a.582.582 0 01.419 1l-1.952 1.918 1.081 2.485a.589.589 0 01-.839.737L12 11.419l-2.615 1.47a.59.59 0 01-.839-.736l1.082-2.485-1.953-1.922a.582.582 0 01.419-1h2.127l1.249-2.454a.6.6 0 011.061 0z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconCertification.displayName = "IconCertification";

export { IconCertification };
